"use strict";

// Pretty stringify
module.exports = function stringify(obj) {
  return JSON.stringify(obj, null, 2);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/lowdb/adapters/_stringify.js
// module id = d0VT
// module chunks = 0